import { Route } from '@angular/router';
import { authGuard } from '@routes/guards/auth.guard';
import { guard } from '@routes/guards/guard-factory';

export const approversRoutes: Route[] = [
    {
        path: 'approvers',
        title: 'PRSS | Согласования',
        loadComponent: () =>
            import('@pages/guids/approvers/approvers.component').then((c) => c.ApproversComponent),
        canActivate: [authGuard, guard('watch_refs_approvers')],
        data: {
            breadcrumbs: [
                { name: 'Справочники', url: '/' },
                { name: 'Согласования', url: null },
            ],
            reuse: true,
            searchString: true,
        },
    },
    {
        path: 'approvers/:id',
        title: 'PRSS | Согласование',
        loadComponent: () =>
            import('@pages/guids/approvers/approver-details/approver-details.component').then(
                (c) => c.ApproverDetailsComponent,
            ),
        canActivate: [authGuard, guard('watch_refs_approvers')],
        data: {
            breadcrumbs: [
                { name: 'Справочники', url: '/' },
                { name: 'Согласования', url: '/approvers/' },
            ],
            searchString: false,
        },
    },
];
